import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { fetchProductDetail } from "../actions/actionCreator";
import Loader from "../components/Loader";

function ProductDetailPage() {
    const { fetchOneProductLoading, product } = useSelector((state) => state.product);
    const { productSlug } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(fetchProductDetail(productSlug));
    }, []);

    if (fetchOneProductLoading) {
        return <Loader />;
    }

    return (
        <>
            <div className="flex flex-row items-start justify-start mt-16 gap-10">
                <div className="w-[50%] h-auto flex flex-row items-center justify-center">
                    <img className="pt-5 h-auto pb-5" src={product.mainImg} alt="" />
                </div>
                <div className=" pt-5 pr-5 w-[50%] h-[100vh] flex flex-col items-start justify-start gap-5">
                    <div className="font-bold text-lg flex flex-row justify-between items-center w-full">
                        <div>{product.Category.name}</div>
                        <div className="text-sm text-white bg-black px-2 py-1 rounded-md font-normal cursor-pointer" onClick={() => {
                            navigate('/products')
                        }}>Back to Product</div>
                    </div>
                    <div className="flex flex-row justify-between w-full items-center">
                        <div>{product.name}</div>
                        <div className="flex flex-row items-center justify-center">
                            <span className="material-symbols-outlined">favorite</span>
                        </div>
                    </div>
                    <div className="w-full flex flex-row justify-between items-center pb-8 border-b-2 border-solid border-gray-200">
                        <div>{product?.price?.toLocaleString("id-ID", { style: "currency", currency: "IDR" })}</div>
                        <div className="flex flex-row items-center justify-center gap-5">
                            <div className="flex flex-row items-center justify-center">
                                <span class="material-symbols-outlined">star</span>
                                <span class="material-symbols-outlined">star</span>
                                <span class="material-symbols-outlined">star</span>
                                <span class="material-symbols-outlined">star</span>
                                <span class="material-symbols-outlined">star</span>
                            </div>
                            <div>2.3 (3)</div>
                        </div>
                    </div>
                    <div className=" underline text-gray-500">Size & Fit Guide (US Size)</div>
                    <div className="grid grid-cols-5 w-[70%] gap-4">
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">5</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">5.5</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">6</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">6.5</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">7</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">8</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">8.5</div>
                        <div className="border-2 border-solid border-gray-500 rounded-lg text-md py-1">9</div>
                    </div>
                    <div className="flex flex-row items-start justify-start gap-5 mt-5 pb-16 border-b-2 border-solid border-gray-200 w-full">
                        <div className=" relative">
                            <select className="w-[5rem] h-[2.5rem] focus:outline-none rounded-md text-center border-2 border-solid border-gray-400">
                                <option value="">1</option>
                                <option value="">2</option>
                                <option value="">3</option>
                                <option value="">4</option>
                            </select>
                            <div className="absolute top-[-9px] left-[22px] bg-white px-1 text-xs">Qty</div>
                        </div>
                        <div>
                            <button className="w-[15rem] bg-red-600 h-[2.5rem] rounded-md text-white hover:bg-red-500">Add to Bag</button>
                        </div>
                    </div>
                    <div className="flex flex-col justify-start items-start gap-4">
                        <div className="font-bold">What's it do?</div>
                        <div className="w-[80%] text-left">"The Project Rock 5s are the most innovative training shoes we've ever made—they give you power, energy, support with an amazing comfort level." – Dwayne Johnson</div>
                    </div>
                </div>
            </div>

            <div className="w-full h-auto grid grid-cols-2 px-10 gap-5">
                {product.Images.map((el) => {
                    return (
                        <div key={el.id}>
                            <img src={el.imgUrl} className="h-auto" alt="image" />
                        </div>
                    )
                })}
                
            </div>
        </>
    );
}

export default ProductDetailPage;
